import React, { useState, useContext, useEffect } from "react"
import PC from "./Filter/PC"
import SP from "./Filter/SP"
import { AreaContext, CategoryContext } from "../Common/FilterConditionsContext"
import { PCViewContext } from "../Common/PCViewContext"
import {
  FilterConditionsHandler,
  FilterConditionsStorage,
} from "../Utils/filter_conditions_handler"
const handler = new FilterConditionsHandler()
import { FeaturedCategories } from "../Utils/category"
import { GeolocationHandler } from "../Utils/geolocation_handler"
const geoHandler = new GeolocationHandler()
import Sentry from "../Common/Sentry"

const filterPrefecture = (locations, prefecture) => {
  if (prefecture == null) {
    return null
  }
  return locations
    .map((l) => l.prefectures)
    .flat()
    .find((p) => p.name == prefecture.name)
}

const getGeoLocation = async (): Promise<any[]> => {
  try {
    const coords = await geoHandler.getPosition()
    const res = await geoHandler.convertToCities(coords)
    if (res.length > 0) {
      return [res[0].city, res[0].prefecture, coords.latitude, coords.longitude]
    }
  } catch (e) {
    Sentry.captureException(e)
    alert("位置情報の取得に失敗しました。エリアを選択してお試しください。")
  }
}

const Filter = (props) => {
  const [showLocationModal, setShowLocationModal] = useState(false)
  const [showCategoryModal, setShowCategoryModal] = useState(false)
  const [city, setCity] = useState(null)
  const [prefecture, setPrefecture] = useState(null)
  const [category, setCategory] = useState(null)
  const [locationText, setLocationText] = useState("エリアを選ぶ")
  const locations = useContext(AreaContext)
  const categories = useContext(CategoryContext)
  const isPC = useContext(PCViewContext)
  const [placeCountByCategories, setPlaceCountByCategories] = useState({})
  const featuredCategories = FeaturedCategories.build(
    props.featuredCategories,
    category
  )

  // prefecture / city切替時に件数取得
  useEffect(() => {
    let mounted = true
    const code = async () => {
      if (mounted) {
        // Reset
        setPlaceCountByCategories({})
        if (prefecture == null) {
          return
        }
        const res = await handler.fetchPlaceCounts({
          by: "category_id",
          prefecture_id: prefecture.id,
          city_id: city ? city.id : null,
        })
        setPlaceCountByCategories(res)
      }
    }
    code()
    return () => {
      mounted = false
    }
  }, [prefecture, city])

  useEffect(() => {
    let mounted = true
    const code = async () => {
      if (mounted) {
        FilterConditionsStorage.setCachedValuesAsDefault({
          setCategory: setCategory,
          setPrefecture: setPrefecture,
          setCity: setCity,
          locations: locations,
          categories: categories,
          setLocationText: setLocationText,
        })
      }
    }
    code()
    return () => {
      mounted = false
    }
  }, [locations, categories])

  const handleCategory = (cat) => {
    if (isNaN(cat.id)) {
      setShowCategoryModal(true)
      return
    }
    setCategory(cat)
    setShowCategoryModal(false)
    FilterConditionsStorage.setCacheValues(cat.id, null, null)
  }
  const handleLocation = async (gotCity, gotPref) => {
    setCity(gotCity)
    setPrefecture(gotPref)
    setShowLocationModal(false)
    props.setCurrentLocation(null)
    if (gotCity || gotPref) {
      setLocationText(gotCity ? gotCity.name : gotPref.name)
      FilterConditionsStorage.setCacheValues(null, gotCity.id, gotPref.id)
    } else {
      props.setCurrentLocation("Loading")
      setLocationText("現在地を取得中…")
      const [resCity, resPref, lat, lon] = await getGeoLocation()
      if (resCity || resPref) {
        setCity(resCity)
        setPrefecture(filterPrefecture(locations, resPref))
        setLocationText(resCity ? resCity.name : resPref.name)
        props.setCurrentLocation({
          latitude: lat,
          longitude: lon,
        })
        FilterConditionsStorage.setCacheValues(null, resCity.id, resPref.id)
      }
    }
  }
  const states = {
    handleCategory,
    handleLocation,
    showLocationModal,
    showCategoryModal,
    city,
    prefecture,
    category,
    locationText,
    locations,
    categories,
    setShowLocationModal,
    setShowCategoryModal,
    placeCountByCategories,
    featuredCategories,
  }

  return (
    <React.Fragment>
      {isPC && <PC {...props} {...states} />}
      {!isPC && <SP {...props} {...states} />}
    </React.Fragment>
  )
}

export default Filter
